<div class="wa-stack">
  <div class="wa-heading-l">Supervisions assigned</div>
  @if (supervisions.length === 0) {
    <wa-callout variant="success">
      <wa-icon slot="icon" name="face-smile" variant="regular"></wa-icon>
      There are currently no supervisions assigned.
    </wa-callout>
  } @else {
    <div class="wa-grid">
      @for (assignment of supervisions; track assignment.id) {
        <app-survey-supervision-list-element
          [exam]="assignment.exam">
        </app-survey-supervision-list-element>
      }
    </div>
  }
</div>
